<template>
  <view class="refund-nav">
    <view wx:if="{{userGroup}}">
      <view wx:if="{{title}}" class="title">{{ title }}</view>
      <view wx:else>改签</view>
    </view>
    <block wx:else>
      <view wx:class="{{process !== 0 ? 'refund-nav-not-now': ''}}">选车次</view>
      <image
        class="refund-nav-arrow"
        src="https://dpubstatic.udache.com/static/dpubimg/mdl6ftoC1AYy5JNVWNNrH.png"
      ></image>
      <view wx:class="{{process !== 1 ? 'refund-nav-not-now': ''}}">选坐席</view>
      <image
        class="refund-nav-arrow"
        src="https://dpubstatic.udache.com/static/dpubimg/mdl6ftoC1AYy5JNVWNNrH.png"
      ></image>
      <view wx:class="{{process !== 2 ? 'refund-nav-not-now': ''}}">选乘客</view>
    </block>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'

  createComponent({
    props: {
      process: {
        type: Number,
        value: 0
      },
      title: {
        value: String,
        value: ''
      }
    },
    computed: {
      ...store.mapState({
        userGroup: 'common.userGroup'
      }),
      changeTitle() {
        return this.title || '改签'
      }
    }
  })
</script>

<style lang="stylus" scoped>
  .refund-nav
    display flex
    flex-direction row
    align-items center
    justify-content center
    font-size 14px
    font-weight 400
    font-family PingFangSC-Medium
    color #000004
    &-arrow
      width 13px
      height 4px
      margin 0 4px
    &-not-now
      color rgba(0, 0, 4, 0.16)
  .title
    font-size 18px
    font-family PingFangSC-Medium
</style>
